var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header"},[_c('div',{staticClass:"box-header__col box-header__title"},[_vm._t("title")],2),_c('div',{staticClass:"box-header__col box-header__col--narrow"},[_vm._t("additional")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }